import * as Fingerprint from 'fingerprintjs';

export function getBrowserFingerprint() {
  const fingerPrint = new Fingerprint().get();

  return fingerPrint;
}
